module.exports = __webpack_public_path__ + "img/nautico.3c1c3b6a.jpg";